import { API_ENDPOINTS, API_HEADERS } from '../constants/api';
import { SalePayload } from '../types';

export const fetchSale = async (): Promise<SalePayload | null> => {
  const response = await fetch(API_ENDPOINTS.sale, {
    headers: API_HEADERS,
  });

  if (!response.ok) {
    throw new Error(`Sale request failed with status ${response.status}`);
  }

  const data = await response.json();

  if (Array.isArray(data)) {
    return data.length > 0 ? (data[0] as SalePayload) : null;
  }

  return data as SalePayload;
};

